import React from "react";
import {RegistrationsReport} from "./RegistrationsReport";

export const RegistrationsReportPage = () => {
    return (<RegistrationsReport/>)
}